import { Router } from '@angular/router';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DetectMethodChanges } from '../utils';
import { LogoutReasonService, LOGOUT_REASON_UI_LAG } from '../logout-reason.service';

@Component({
  template: `
    <dx-popup   class="popup"
            [width]="500"
            [height]="200"
            [showTitle]="false"
            [closeOnOutsideClick]="false"
            [resizeEnabled]="false"
            [dragEnabled]="false"
            [visible]="true">
        <div *dxTemplate="let data of 'content'">
            <div class="message">
                <p>
                    {{ message }}
                </p>
            </div>
            <div class="ok-button">
                <dx-button
                        text="OK"
                        (onClick)="logout()"
                        width="100"
                        type="default"></dx-button>
            </div>
        </div>
    </dx-popup>
    `,
  styles: [
    `
      .message {
        position: relative;
        height: 68%;
      }

      .ok-button {
        position: relative;
        text-align: right;
        margin-right: 25px;
      }

      p {
        font-size: 1.5em;
        text-align: center;
        padding-top: 50px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    private _changeDetector: ChangeDetectorRef,
    private _logoutReasonService: LogoutReasonService,
  ) {}

  message = `Your session has been expired. Click 'OK' to re-login`;

  ngOnInit(): void {
    const reason = this._logoutReasonService.getAndClearReason();
    if (reason === 'UILagDetected') {
      this.message = LOGOUT_REASON_UI_LAG;
    }
  }

  @DetectMethodChanges({isAsync: true})
  async logout(): Promise<void> {
    await this.router.navigate(['/login']);
  }
}
